import React from 'react';
import { FormattedMessage } from 'react-intl';
import { CP_GO_URL_FAQ } from 'constants/go';

export const GoProductLinks = () => (
  <li>
    <a href={CP_GO_URL_FAQ} target="_blank" rel="noopener noreferrer">
      <FormattedMessage id="header.link.go.faq" defaultMessage="FAQ" />
    </a>
  </li>
);
